import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ConfigurationService } from "../configuration/configuration.service";

// A bare array of these, no envelope. patient_chart_id is the EXTERNAL (QBOS)
// chart id, the same semantics the QA queue's pat_chart_id carries; the payload
// has no internal id. Both timestamps are "yyyy-MM-dd'T'HH:mm:ss" with no zone
// and either can arrive as an explicit null.
export interface OpenVisit {
  patient_chart_id: number;
  assessment_id: number;
  patient_name: string;
  performed_by: string;
  role_lookup_code: string;
  started_dte: string;
  system_started_dte: string;
  status_lookup_code: string;
}

@Injectable()
export class OpenVisitsService {
  private readonly idgDataUrl: string;

  constructor(public http: HttpClient, private config: ConfigurationService) {
    if (this.config.getConfig().isLocal) {
      this.idgDataUrl = config.getConfig().localEndpoints.idgUrl;
    } else {
      this.idgDataUrl = config.getConfig().apiUrl + "/idg";
    }
  }

  getOpenVisitsForTeam(teamId: number): Observable<OpenVisit[]> {
    return this.http.get<OpenVisit[]>(
      `${this.idgDataUrl}/open-visits/team/${teamId}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/open-visits/open-visits.service.ts